/* eslint-disable */
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
  EventEmitter
} from "@angular/core";
import { MediaMatcher } from "@angular/cdk/layout";
import { LayoutService } from "../services/layout.service";
import { untilDestroyed } from "ngx-take-until-destroy";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { NavigationEnd, Router, Scroll, NavigationStart } from "@angular/router";
import { filter, map, startWith } from "rxjs/operators";
import { checkRouterChildsData } from "../utils/check-router-childs-data";
import { DOCUMENT } from "@angular/common";
import { SidebarComponent } from "../components/sidebar/sidebar.component";
import { ConfigService } from "../services/config.service";
import { MediaObserver } from "@angular/flex-layout";
import { NavigationService } from '../services/navigation.service';
import { SharedService } from 'src/app/pages/Services/shared.service';
import { EvoGlobalService } from 'src/app/globals/evo-global.service';
import { HistoryService } from '../services/history.service';

@Component({
  selector: "nc-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"]
})
export class LayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  isLayoutVertical$ = this.configService.config$.pipe(
    map(config => config.layout === "vertical")
  );
  isBoxed$ = this.configService.config$.pipe(map(config => config.boxed));
  isToolbarFixed$ = this.configService.config$.pipe(
    map(config => config.toolbar.fixed)
  );
  isFooterFixed$ = this.configService.config$.pipe(
    map(config => config.footer.fixed)
  );
  isFooterVisible$ = this.configService.config$.pipe(
    map(config => config.footer.visible)
  );
  sidenavCollapsed$ = this.layoutService.sidenavCollapsed$;

  mobileQuery = this.mediaMatcher.matchMedia("(max-width: 1279px)");

  triggerScreen = true;


  toolbarShadowEnabled$ = this.router.events.pipe(
    filter<NavigationEnd>(event => event instanceof NavigationEnd),
    startWith(null),
    map(() =>
      checkRouterChildsData(
        this.router.routerState.root.snapshot,
        data => data.toolbarShadowEnabled
      )
    )
  );

  scrollDisabled$ = this.router.events.pipe(
    filter<NavigationEnd>(event => event instanceof NavigationEnd),
    startWith(null),
    map(() =>
      checkRouterChildsData(
        this.router.routerState.root.snapshot,
        data => data.scrollDisabled
      )
    )
  );

  containerEnabled$ = this.router.events.pipe(
    filter<NavigationEnd>(event => event instanceof NavigationEnd),
    startWith(null),
    map(() =>
      checkRouterChildsData(
        this.router.routerState.root.snapshot,
        data => data.containerEnabled
      )
    )
  );

  // @ViewChild("quickpanel", { static: true }) quickpanel: MatSidenav;
  @ViewChild("sidenav", { static: true }) sidenav: MatSidenav;
  @ViewChild("configpanel", { static: true }) configpanel: SidebarComponent;
  @ViewChild(MatSidenavContainer, { static: true })
  sidenavContainer: MatSidenavContainer;
  crumbs: any[] = [];

  menuData: any;
  isMenuDisplay: boolean = false;
  private _mobileQueryListener: () => void;

  constructor(
    public navigationService: NavigationService,
    private cd: ChangeDetectorRef,
    private mediaMatcher: MediaMatcher,
    private mediaObserver: MediaObserver,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private router: Router,
    private sharedService: SharedService,
    private evoGlobalService: EvoGlobalService,
    private historyService: HistoryService,
    @Inject(DOCUMENT) private document: Document
  ) {

    //console.log("layout component");
    //this.sharedService.getPraparedMenuItem().subscribe( result => this.navigationService.items = result);
    //this.navigationService.items =  JSON.parse(localStorage.getItem("mainMenu"));

    //breadcrumbs code
    // this.sharedService.getScreenPermssionList().subscribe(result => {
    //   //console.log("layout getScreenPermssionList()" ,result);
    //   this.navigationService.menuItems = [...result['menu']];
    // });

    // let url = window.location.href;
    // let startIndex = url.indexOf('/layout');
    // let lastIndex;
    // let currentRoute;
    // if(url.indexOf("?")==-1){
    //   currentRoute = url.substr(startIndex);
    // } else {
    //   lastIndex = url.indexOf("?");
    //   currentRoute = url.substring(startIndex, lastIndex);
    // }
    // this.navigationService.updateCrumbsByRoute(currentRoute);
    // console.log(url, currentRoute, url.indexOf("?"),"teen teen");
    // this.navigationService.currentRoute = currentRoute;
    //let navArr = JSON.parse(localStorage.getItem("navMenuData"));

    // if(!this.navigationService.menuItems || (this.navigationService.menuItems && this.navigationService.menuItems.length==0)) {
    //   let navArr:any[]=[];
    //   this.sharedService.getScreenPermssionList().subscribe(result => navArr = result);
    //   //let navArr = JSON.parse(localStorage.getItem("navMenuData"));
    //   this.navigationService.menuItems = [...navArr];
    // }
    // if(!this.navigationService.currentRoute) {

    //   let currentRoute = JSON.parse(localStorage.getItem("currentRoute"));
    //   this.navigationService.currentRoute = currentRoute;
    //   if(currentRoute && currentRoute.menuName == "Dashboard") {
    //     this.navigationService.crumbs = ["Dashboard"];
    //   } else {
    //     currentRoute && this.navigationService.updateCrumbs(currentRoute);
    //   }
    // } else {
    //   if(this.navigationService.currentRoute.menuName == "Dashboard") {
    //     this.navigationService.crumbs = ["Dashboard"];
    //   } else {
    //     this.navigationService.updateCrumbs(this.navigationService.currentRoute);
    //   }
    // }
    //breadcrumbs code
  }

  ngOnInit() {//this.sharedService.getPraparedMenuItem().subscribe(result => console.log(result));
    this.setQuickMenuSetting();

    this.sharedService.getPraparedMenuItem().subscribe(menuItemList => {
      //console.log(menuItemList);
      //console.log("layout");
      this.navigationService.items = menuItemList;
    });
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.setQuickMenuSetting();
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe((event: NavigationStart) => {
      this.isMenuDisplay = false;
      this.menuData = undefined;
    });

    this._mobileQueryListener = () => this.cd.detectChanges();
    this.mobileQuery.addEventListener("change", this._mobileQueryListener);

    this.mediaObserver
      .asObservable()
      .pipe(
        filter(() => this.mediaObserver.isActive("lt-lg")),
        untilDestroyed(this)
      )
      .subscribe(() => this.layoutService.expandSidenav());

    // this.layoutService.quickpanelOpen$
    //   .pipe(untilDestroyed(this))
    //   .subscribe(open =>
    //     open ? this.quickpanel.open() : this.quickpanel.close()
    //   );

    this.layoutService.sidenavOpen$
      .pipe(untilDestroyed(this))
      .subscribe(open => (open ? this.sidenav.open() : this.sidenav.close()));

    this.layoutService.configpanelOpen$
      .pipe(untilDestroyed(this))
      .subscribe(open =>
        open ? this.configpanel.open() : this.configpanel.close()
      );

    this.router.events
      .pipe(
        filter<NavigationEnd>(event => event instanceof NavigationEnd),
        filter(() => this.mobileQuery.matches),
        untilDestroyed(this)
      )
      .subscribe(() => this.sidenav.close());

    //crumbs code
    //console.log(this.router.url, "router url");
  }

  setQuickMenuSetting() {
    this.sharedService.getQuickMenuSettings('quickMenu').subscribe(quickMenuList => {
      const quickMenuKeys = Object.keys(quickMenuList);
      const path = this.router.url.split('/');
      const actualPath = path[path.length - 1].split('?');
      for (let ele of quickMenuKeys) {
        if (actualPath[0] === ele && quickMenuList[ele]) {
          this.sharedService.getQuickMenuSettings(actualPath[0]).subscribe(menuData => {
            this.menuData = menuData;
            this.isMenuDisplay = true;
          }, err => {
            this.menuData = undefined;
            this.isMenuDisplay = false;
          });
          break;
        }
      }
    });
  }

  ngAfterViewInit(): void {
    this.router.events
      .pipe(
        filter<Scroll>(e => e instanceof Scroll),
        untilDestroyed(this)
      )
      .subscribe(e => {
        if (e.position) {
          // backward navigation
          this.sidenavContainer.scrollable.scrollTo({
            start: e.position[0],
            top: e.position[1]
          });
        } else if (e.anchor) {
          // anchor navigation

          const scroll = (anchor: HTMLElement) =>
            this.sidenavContainer.scrollable.scrollTo({
              behavior: "smooth",
              top: anchor.offsetTop,
              left: anchor.offsetLeft
            });

          let anchorElem = this.document.getElementById(e.anchor);

          if (anchorElem) {
            scroll(anchorElem);
          } else {
            setTimeout(() => {
              anchorElem = this.document.getElementById(e.anchor);
              scroll(anchorElem);
            }, 100);
          }
        } else {
          // forward navigation
          this.sidenavContainer.scrollable.scrollTo({
            top: 0,
            start: 0
          });
        }
      });
  }

  openConfigPanel() {
    this.configpanel.open();
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeEventListener("change", this._mobileQueryListener);
  }


  hideSideNav() {  
    // return this.quickpanel.toggle();
  }  

}
